import Vue from "vue";
import Router from "vue-router";
import session from "@/utils/session";
import HomeV from "@/views/Home.vue";
import LoginV from "@/views/Login.vue";
import NaverV from "@/views/Naver.vue";
import LgLoginV from "@/views/LgLogin.vue";
import QrLoginV from "@/views/QrLogin.vue";
import MobileLoginV from "@/views/MobileLogin.vue";
import LoginErrorV from "@/views/LoginError.vue";

Vue.use(Router);

const setTheme = () => async (from, to, next) => {
    if (from.query.hasOwnProperty('theme')) {
        session.set_theme(from.query.theme)
    }
    next()
};

const router = new Router({
    mode: 'history',
    routes: [
        {
            path: "/",
            name: "Home",
            component: HomeV,
            beforeEnter: setTheme()
        },
        {
            path: "/login",
            name: "Login",
            component: LoginV,
        },
        {
            path: '/naver',
            name: "Naver",
            component: NaverV
        },
        {
            path: "/lgLogin",
            name: "LgLogin",
            component: LgLoginV,
        },
        {
            path: "/qrLogin",
            name: "QrLogin",
            component: QrLoginV,
        },
        {
            path: "/MoblieLogin",
            name: "MobileLogin",
            component: MobileLoginV,
        },
        {
            path: '/LoginError',
            name: "LoginError",
            component: LoginErrorV
        },
        {
            path: '*',
            component: HomeV,
            beforeEnter: setTheme()
        }
    ]
});

export default router;
